/**
 * @generated SignedSource<<1b9f395c58e31e770a602389b192fa33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectFragment$data = {
  readonly id: string;
  readonly name: string | null | undefined;
  readonly number: string | null | undefined;
  readonly status: number | null | undefined;
  readonly statusItem: {
    readonly code: string | null | undefined;
    readonly id: string | null | undefined;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "ProjectFragment";
};
export type ProjectFragment$key = {
  readonly " $data"?: ProjectFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ListItem",
      "kind": "LinkedField",
      "name": "statusItem",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Project",
  "abstractKey": null
};
})();

(node as any).hash = "6a86a3b8c4545d3378a287dd1d517ba2";

export default node;
